<template>
  <div class="container">
    <div
      id="page1-div"
      class="container interline border page-container"
    >
      <div class="col-12 p-4">
        <div class="col-12 text-center pt-4 pb-3">
          <u class="ft12Black">
            ACUERDO DE ABONO EN ESPECIE AL ADEUDO CESIÓN DE DERECHOS
          </u>
        </div>
        <div class="col-12 text-justify pt-4">
          <span class="ft10">
            Apoderado o Representante Legal de<br />
            GPI AUTO COMERCIAL SAPI DE C.V.
            <br />
            <br />
            Que por nuestro propio derecho y, en mi carácter de: (i) Acreditado,
            y en comparecencia, el Obligado Solidario, exponemos que respecto
            del crédito que fuera otorgado a nuestro favor y a cargo de GPI AUTO
            COMERCIAL SAPI DE C.V. (en adelante "
            <u class="ft10">ACREEDOR</u>"), por la cantidad de principal de
            <span v-bind:class="{ marca: data.showMarca }" class="ft10">
              ${{ data.monto_a_finaciar }} {{data.monto_a_finaciar_letra}},
            </span>
            el cual se encuentra documentado a través del contrato de apertura
            de CRÉDITO SIMPLE CON GARANTÍA PRENDARIA SIN TRANSMISIÓN DE LA
            POSESIÓN celebrado, el día
            <span v-bind:class="{ marca: data.showMarca }">{{
              data.fecha_contrato.toUpperCase()
            }},</span>
             entre el(los) suscrito(s) y ACREEDOR (en adelante el "
            <span v-bind:class="{ marca: data.showMarca }">
              {{data.fecha_contrato.toUpperCase()}},
            </span>
            entre el(los) suscrito(s) y ACREEDOR (en adelante el "
            <u class="ft10">Contrato</u>"), mismo que sería pagadero en forma
            mensual, mediante
            <span v-bind:class="{ marca: data.showMarca }">{{ data.plazo }}</span>
            exhibiciones consecutivas e ininterrumpidas, cada una por la
            cantidad de
            <span v-bind:class="{ marca: data.showMarca }">
              ${{ data.mensualidad }} {{ data.mensualidad_letra }},
            </span>
            a partir del día
            <span v-bind:class="{ marca: data.showMarca }">
              {{ data.fecha_primer_pago }},
            </span>
             los días
            los días
            <span v-bind:class="{ marca: data.showMarca }">{{
              data.dias_de_abono
            }}</span>
            de cada MES subsecuente (en adelante el "
            <u class="ft10">Crédito</u>"); y, (ii) garante(s) prendario(s),
            respecto de la prenda constituida a nuestro cargo y a favor de GPI
            AUTO COMERCIAL SAPI DE C.V., en primer lugar y grado sobre el
            Vehículo marca
            <span v-bind:class="{ marca: data.showMarca }">
              {{data.marca_vehiculo}},
            </span> año
            <span v-bind:class="{ marca: data.showMarca }">
              {{data.año_vehiculo}},
            </span> modelo
            <span v-bind:class="{ marca: data.showMarca }">
              {{data.modelo_vehiculo}},
            </span> con numero de serie
            <span v-bind:class="{ marca: data.showMarca }">
              {{data.numero_serie_vehiculo.toUpperCase()}},
            </span> número de motor
            <span v-bind:class="{ marca: data.showMarca }">
             {{data.numero_motor_vehiculo.toUpperCase()}},
            </span> (en adelante el "
            <u v-bind:class="{ marca: data.showMarca }" class="ft10">{{
              data.tipo_vehiculo
            }}</u
            >") para garantizar el pago del Crédito; ocurrimos a manifestar, lo
            que a continuación se asienta:
            <br />
            <br />
            a)&emsp; Que reconocemos a GPI AUTO COMERCIAL SAPI DE C.V. como
            acreedor del Crédito y, en consecuencia, como acreedor prendario del
            Vehículo.
            <br />
            b)&emsp; Que reconocemos y aceptamos que a la fecha del presente
            documento adeudamos a GPI AUTO COMERICAL, SAPI DE C.V. la cantidad
            total de (en lo sucesivo el " <u class="ft10">Adeudo</u>"), con base
            en lo establecido en el Contrato.
            <br />

            c)&emsp; Que toda vez que carecemos de los recursos económicos
            suficientes para el pago a favor de GPI AUTO COMERCIAL SAPI DE
            C.V., del Adeudo, mismo que se encuentra vencido y exigible a
            nuestro cargo a la fecha señalada al margen superior del presente
            documento; por este conducto y atento a lo establecido por el
            artículo 344 de la Ley General de Títulos y Operaciones de Crédito,
            en forma expresa e irrevocable, otorgamos nuestro consentimiento a
            favor de GPI AUTO COMERCIAL SAPI DE C.V. para que pueda hacerse
            dueño del Vehículo, con el objeto de que GPI AUTO COMERCIAL SAPI DE
            C.V., aplique el valor del Vehículo incluido en el inciso c)
            anterior al pago del Adeudo. Consecuentemente, en dación en pago,
            transmitimos la propiedad y dominio del Vehículo, sin reserva ni
            limitación alguna, a favor de GPI AUTO COMERCIAL SAPI DE C.V.
            <br />
            d)&emsp; Que la transmisión del Vehículo a favor de GPI AUTO
            COMERCIAL SAPI DE C.V., comprende la de todos aquellos derechos
            accesorios que le sean relativos. Que la entrega material del
            Vehículo se realizará dentro de los 5 (cinco) días hábiles
            posteriores a la firma del presente documento, en las oficinas de
            GPI AUTO COMERCIAL SAPI DE C.V. Que por medio del presente se
            deslinda a GPI AUTO COMERCIAL SAPI DE C.V. de cualquier delito,
            violación a la ley local y Federal de
            <br />
            e)&emsp; tránsito anterior a la fecha y hora del presente documento,
            cesión de derechos "dación en pago" y a petición de la parte
            acreedora, a partir del kilometraje marcado de la unidad.
            <br />
            <br />
            De igual forma acordamos que si una vez aplicado el valor comercial
            del Vehículo para el pago del Adeudo, no se encuentra cubierto la
            totalidad del Adeudo, me obligo a realizar de inmediato a mi cuenta
            y costa, el pago total del saldo insoluto del Adeudo, hasta cubrir
            la totalidad del mismo con base en lo establecido en el Contrato,
            reservándose GPI AUTO COMERCIAL SAPI DE C.V. sus derechos y
            manteniéndose vigentes y exigibles todas las obligaciones a mi cargo
            establecidas en el Contrato.
            <br /><br />
            El Acreditado acepta toda responsabilidad civil, penal o de transito
            en que se haya involucrado, con anterioridad a este acto, con
            respecto al citado Vehículo. Consecuentemente, a partir de la hora y
            fecha de celebración de la presente carta responsiva, GPI AUTO
            COMERCIAL SAPI DE C.V. asume cualquier responsabilidad y/u
            obligación que se derive respecto de y/o sea inherente a dicho
            Vehículo.
            <br /><br />
            GPI AUTO COMERCIAL SAPI DE C.V. gestionará y dará el o los avisos
            de cambio de propietario del citado vehículo que deban presentarse a
            las autoridades competentes.
            <br /><br />
            En caso de que cualquier disposición del presente documento sea
            declarada nula por cualquier tribunal competente, el suscrito y GPI
            AUTO COMERCIAL SAPI DE C.V. acuerdan que dicha invalidez no
            afectará la validez y exigibilidad de las disposiciones incluidas en
            el Contrato.
            <br /><br />
            Que para el supuesto de que por su conducto GPI AUTO COMERCIAL SAPI
            DE C.V. otorgue su anuencia a lo establecido con antelación, deberá
            firmar de aceptación y conformidad al calce del presente.
          </span>
        </div>
        <div class="col-12 row p-3">
          <div class="col-3 text-center"></div>
          <div class="col-6 border-dark text-center">
            <span class="ft11">
              ATENTAMENTE
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
        <div v-if="data.tipoClasico" class="col-12 row">
          <div class="col-3 text-center"></div>
          <div class="col-6 border-bottom border-dark text-center">
            <span v-bind:class="{ marca: data.showMarca }" class="ft11 ">
              {{ data.nombre_cliente }}
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
        <div v-if="data.tipoClasico" class="col-12 row ">
          <div class="col-3 text-center"></div>
          <div class="col-6 text-center pb-5">
            <span class="ft11">
              NOMBRE Y FIRMA DEL ACREDITADO
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
        <div v-if="data.tipoAval" class="col-12 row pt-4">
          <div class="col-4 offset-1 border-top border-dark text-center">
            <span class="ft11">
              <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
                {{ data.nombre_cliente }}</span
              ><br />
              NOMBRE Y FIRMA DEL ACREDITADO
            </span>
          </div>
          <div class="col-3 text-center">
            <span class="ft11">

            </span>
          </div>
          <div class="col-4 border-top border-dark text-center">
            <span class="ft11">
              <span v-bind:class="{ 'marca-aval': data.showMarca }" class="ft10Black">
                {{ data.nombre_aval }}</span
              ><br />
              NOMBRE Y FIRMA DEL AVAL Y OBLIGADO SOLIDARIO

            </span>
          </div>
        </div>
        <div v-if="data.tipoObligado" class="col-12 row pt-4">
          <div class="col-4 offset-1 border-top border-dark text-center">
            <span class="ft11">
              <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
                {{ data.nombre_cliente }}</span
              ><br />
              NOMBRE Y FIRMA DEL ACREDITADO
            </span>
          </div>
          <div class="col-3 text-center">
            <span class="ft11">

            </span>
          </div>
          <div class="col-4 border-top border-dark text-center">
            <span class="ft11">
              <span v-bind:class="{ 'marca-obligado': data.showMarca }" class="ft10Black">
                {{ data.nombre_obligado }}</span
              ><br />
              NOMBRE Y FIRMA DEL AVAL Y OBLIGADO SOLIDARIO

            </span>
          </div>
        </div>
        <div v-if="data.tipoObligadoAval" class="col-12 row pt-4">
          <div class="col-3 offset-1 border-top border-dark text-center">
            <span class="ft9">
              <span v-bind:class="{ marca: data.showMarca }" class="ft9Black">
                {{ data.nombre_cliente }}</span
              ><br />
              NOMBRE Y FIRMA DEL ACREDITADO
            </span>
          </div>
          <div class="col-3 offset-1 border-top border-dark text-center">
            <span class="ft9">
              <span v-bind:class="{ 'marca-aval': data.showMarca }" class="ft9Black">
                {{ data.nombre_aval }}</span
              ><br />
              NOMBRE Y FIRMA DEL AVAL Y OBLIGADO SOLIDARIO

            </span>
          </div>
          <div class="col-3 offset-1 border-top border-dark text-center">
            <span class="ft9">
              <span v-bind:class="{ 'marca-obligado': data.showMarca }" class="ft9Black">
                {{ data.nombre_obligado }}</span
              ><br />
              NOMBRE Y FIRMA DEL“AVAL Y OBLIGADO SOLIDARIO"

            </span>
          </div>
        </div>
        <div class="col-12 row pt-4">
          <div class="col-3 text-center"></div>
          <div class="col-6 border-bottom border-dark text-center"></div>
          <div class="col-3 text-center"></div>
        </div>
        <div class="col-12 row ">
          <div class="col-3 text-center"></div>
          <div class="col-6 text-center">
            <span class="ft11">
              Aceptación y Conformidad<br />
              GPI AUTO COMERCIAL SAPI DE C.V.<br />
              Por: Representante Legal
            </span>
          </div>
          <div class="col-3 text-center"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "IntruccionPAgoTErceros",
  data() {
    return {};
  },
  validations() {
    return {};
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {},
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "../style.scss";
</style>



// WEBPACK FOOTER //
// src/views/Contratos/cartas/AdeudoCesionDerechos.vue